/**
 * The one number locale, for every surface.
 *
 * The customer-facing UI is English (CLAUDE.md "Language") and so is its
 * number format: `1,648` and `€16.4K` whatever the browser locale. Pinned in
 * three runtimes that would otherwise disagree — the app (a browser's locale),
 * the vitest runner (nl on this machine) and the report renderer's headless
 * Chromium (whatever the image says) — and matching
 * `react/formatValue.ts` and the Python formatter.
 *
 * Declared HERE rather than in `apps/frontend/src/utils/metricFormat.ts`
 * (which re-exports it) since 2026-09-08: the builder that formats a tooltip
 * and the table under it must not be able to hold two equal strings that can
 * drift apart. One definition.
 */
export const NUMBER_LOCALE = "en-US";
